import SweetAlert from 'sweetalert2'

export const showAlert = async (html, confirmButtonText = 'Update') => {
    const result = await SweetAlert.fire({
        title: "Are you sure?",
        html, icon: "warning",
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText: "Cancel",
        reverseButtons: true,
    })
    return result.isConfirmed
}
export const showAlertDelete = async (text, confirmButtonText = 'Delete', cancelButtonText = 'Cancel', cancelButtonColor = '#dd3333') => {
    const result = await SweetAlert.fire({
        title: "Are you sure?",
        text,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText,
        cancelButtonColor,
        reverseButtons: true,
    })
    return result.isConfirmed
}